const firebaseConfigProduction = {
  apiKey: 'AIzaSyD7QpZKyHNIhwYu-2y0vaHJB_bOB7eJG4s',
  authDomain: 'dailydosersapp.firebaseapp.com',
  projectId: 'dailydosersapp',
  storageBucket: 'dailydosersapp.appspot.com',
  messagingSenderId: '393136348374',
  appId: '1:393136348374:web:06b92ca2a3a5e381ab7d77',
  measurementId: 'G-DRT93M8TRL',
}

export default firebaseConfigProduction
